import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CardSortOrderSetting as SchemaCardSortOrderSetting } from '../schemas/CardSortOrderSetting';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Products
 */
export const GetProductsCardSortOrderSettingsContentType = '' as const;
export type GetProductsCardSortOrderSettingsRequest = void;
export type GetProductsCardSortOrderSettingsResponses = LinkCommonErrorResponses & {
    '200': {
        'application/json': SchemaCardSortOrderSetting;
    };
};
export type GetProductsCardSortOrderSettingsResponseSuccess =
    GetProductsCardSortOrderSettingsResponses['200']['application/json'];
export type GetProductsCardSortOrderSettingsSearchParams = undefined;
export type GetProductsCardSortOrderSettingsPathParameters = undefined;
export const GetProductsCardSortOrderSettingsUrl = '/products/settings/card_sort_order' as const;
export const GetProductsCardSortOrderSettingsMethod = 'GET' as const;
export const getGetProductsCardSortOrderSettingsUrl = (_params?: GetProductsCardSortOrderSettingsPathParameters) =>
    GetProductsCardSortOrderSettingsUrl;
